/* 「チャットで尋ねる」のリンク（data-doel-open-chat）から、Shopify Inbox のチャットを開く。
 * Inbox の部品 <shopify-chat> は影の中にボタンを持つので、それを押す。
 * チャットが無い（埋め込みがオフ等）ときは、よくあるご質問へ送る。2026-09-30 */
document.addEventListener('click', function (e) {
  var link = e.target.closest && e.target.closest('[data-doel-open-chat]');
  if (!link) return;
  e.preventDefault();
  document.documentElement.classList.remove('doel-menu-open');
  var chat = document.querySelector('shopify-chat');
  var button = chat && chat.shadowRoot && chat.shadowRoot.querySelector('button');
  if (button) button.click();
  else window.location.href = '/pages/faq';
});
